<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Envois Express" />
            <EnvoiExpress />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import EnvoiExpress from '../Services/EnvoiExpress'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'EnvoiExpressPage',
    components: {
        NavBar,
        PageTitle,
        EnvoiExpress,
        FooterComp,
    }
}
</script>